import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=5c2222ee&scoped=true&"
var script = {}
import style0 from "./Business.vue?vue&type=style&index=0&id=5c2222ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2222ee",
  null
  
)

export default component.exports